var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcNext = function SvgIcNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.782 8.467a.753.753 0 0 0 0-1.062l-4.77-4.785a.747.747 0 0 0-1.058 0 .753.753 0 0 0 0 1.062l3.492 3.504H2.764a.75.75 0 1 0 0 1.5h9.682L8.954 12.19a.753.753 0 0 0 0 1.062.747.747 0 0 0 1.058 0l4.77-4.785Z"
  })));
};
export default SvgIcNext;